import { defaultHttpClient } from '../../httpClient';
import type {
  GetMarketRankingsRequest,
  GetMarketRankingsResponse,
} from './types';

export const getMarketRankings = ({
  market_type_sno,
  next_token,
  category_sno,
  age_list,
  style_list,
}: GetMarketRankingsRequest) => {
  return defaultHttpClient
    .request<GetMarketRankingsResponse>(
      {
        method: 'GET',
        url: `/api/v2/markets/rankings/${market_type_sno}/`,
        params: {
          next_token,
          category_sno,
          'age_list[]': age_list,
          'style_list[]': style_list,
        },
      },
      {
        arrayFormat: 'repeat',
      },
    )
    .then(result => result.data);
};
